
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50.109","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"sort-arrow-down",attrs:{"d":"M26.699 33.39c-.85-.748-2.232-.635-2.98.214l-7.884 8.888V6.972c0-1.167-.962-2.129-2.13-2.129s-2.13.962-2.13 2.13v35.519l-7.883-8.888c-.85-.85-2.13-.962-2.98-.215-.85.85-.962 2.13-.215 2.98l11.611 12.993c.87 1.075 2.407.911 3.093 0L26.914 36.37c.747-.84.645-2.232-.215-2.98z"}}),_c('path',{staticClass:"sort-arrow-up",attrs:{"d":"M49.501 13.792L37.993.799c-1.024-1.035-2.304-1.096-3.195 0L23.085 13.792c-.748.85-.635 2.232.215 2.98 1.31 1.044 2.631.327 2.98-.216l7.883-8.887v35.417c0 1.167.963 2.13 2.13 2.13s2.13-.85 2.13-2.028V7.68l7.884 8.888c.85.85 2.13.962 2.98.215.849-.86.962-2.14.214-2.99z"}})])
          )
        }
      }
    